import { Trans, useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import type { FontVariant } from './fontVariant';
import { MissMatchContextVariableTypePayload } from 'src/types/ErrorEventTypes';

export const MissMatchContextVariableFix = ({
  fontVariant = 'font16',
  payload,
}: {
  fontVariant?: FontVariant;
  payload: MissMatchContextVariableTypePayload;
}) => {
  const { t } = useTranslation('events');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography variant={fontVariant}>
        {t('missMatchContextVariableFix.intro')}
      </Typography>
      <Typography variant={fontVariant}>
        <Trans
          components={{ bold: <strong /> }}
          i18nKey='missMatchContextVariableFix.mismatchedVariable'
          ns='events'
          values={{ failedCv: payload.failed_cv }}
        />
      </Typography>
      <Typography variant={fontVariant}>
        <Trans
          components={{ bold: <strong /> }}
          i18nKey='missMatchContextVariableFix.mismatchedValue'
          ns='events'
          values={{ cvValue: payload.cv_value }}
        />
      </Typography>
      <Typography variant={fontVariant}>
        <Trans
          components={{ bold: <strong /> }}
          i18nKey='missMatchContextVariableFix.contextVariableId'
          ns='events'
          values={{ cvId: payload.cv_id }}
        />
      </Typography>
      <Typography variant={fontVariant}>
        {t('missMatchContextVariableFix.stepsToFix')}
      </Typography>
      <Typography variant={fontVariant}>
        {t('missMatchContextVariableFix.step1')}
      </Typography>
      <Typography variant={fontVariant}>
        {t('missMatchContextVariableFix.step2')}
      </Typography>
      <Typography variant={fontVariant}>
        {t('missMatchContextVariableFix.step3')}
      </Typography>
    </Box>
  );
};
